export enum Kind {
  NAME = 'Name',
  DOCUMENT = 'Document',
  OPERATION_DEFINITION = 'OperationDefinition',
}
